import { useMamAssets } from '~services/api/hooks/mam-assets.hooks';
import { MamAsset } from './MamAsset';

type MamAssetsProps = {
  assetIds: number[];
};

export const MamAssets = ({ assetIds }: MamAssetsProps) => {
  const { data } = useMamAssets(assetIds);

  if (data?.length) {
    return (
      <>
        {data.map(asset => (
          <MamAsset asset={asset} key={`mam_asset_${asset.id}`} />
        ))}
      </>
    );
  }

  return null;
};
